export enum productPromoCodeType {
	FIXED_VALUE = 1,
	PERCENTAGE = 2,
	OFFER = 3,
}
export enum offersStatusEnum {
	CURRENT_PROMO_CODE = 0,
	ENDED_PROMO_CODE = 1,
}
export enum ActivationEnum {
	ACTIVE = 1,
	INACTIVE = 2,
}
export enum LabelEnum {
	LABELED = 1,
	NOT_LABELED = 2,
}
